/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module NatModule */

import { Injector } from '@angular/core';

import {
    NatPolicyCollection,
} from 'ajs/modules/policies/factories/nat-policy/nat-policy-collection.factory';

import { NAT_POLICY_COLLECTION_TOKEN } from 'ajs/modules/policies/policies.tokens';

const $injector = '$injector';

export const natPolicyCollectionProvider = {
    deps: [$injector],
    provide: NatPolicyCollection,
    useFactory(injector: Injector): typeof NatPolicyCollection {
        return injector.get(NAT_POLICY_COLLECTION_TOKEN);
    },
};
